import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { Media } from '@quorum/models/xs-resource';
import { MediaStateService } from '@quorum/sha-media';
import { RouterStateService } from '@quorum/sha-router';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Location } from '@angular/common';

@Component({
  selector: 'svc-vehicle-media-gallery',
  templateUrl: './vehicle-media-gallery.component.html',
  //providers: [GroupByPipe],
  styleUrls: ['./vehicle-media-gallery.component.scss'],
})
export class VehicleMediaGalleryComponent implements OnInit, OnDestroy {
  vehicleMediaLoaded$: Observable<boolean>;
  media$: Observable<Media[]>;
  isPopoverOpen: boolean = false;
  showClearButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private mediaStateService: MediaStateService,
    private route: ActivatedRoute,
    //private groupByPipe: GroupByPipe,
    private routerStateService: RouterStateService,
    private location: Location,
  ) {}

  ngOnDestroy() {
    this.showClearButton$.unsubscribe();
  }

  ngOnInit(): void {
    this.vehicleMediaLoaded$ = this.mediaStateService.getVehicleMediaLoaded();

    this.mediaStateService.loadMediaForVehicle(this.route.snapshot.params.vehicleId);

    this.media$ = combineLatest([
      this.route.queryParams.pipe(filter((params) => params !== null)),
      this.mediaStateService.getVehicleMedia(),
    ]).pipe(
      map(([queryParams, media]) => {
        if (queryParams && Object.keys(queryParams).length !== 0) {
          this.showClearButton$.next(true);
        } else {
          this.showClearButton$.next(false);
        }
        let paramsArray = Object.entries(queryParams);
        let filteredMedia: Media[] = media;
        paramsArray.forEach((queryParam) => {
          switch (queryParam[0]) {
            case 'workOrderId':
              filteredMedia = filteredMedia.filter((media) => {
                return media.tags.workOrderId === parseInt(queryParam[1].toString());
              });
              break;
            case 'appointmentId':
              filteredMedia = filteredMedia.filter((media) => {
                return media.tags.appointmentId === parseInt(queryParam[1].toString());
              });
              break;
            case 'damageId':
              filteredMedia = filteredMedia.filter((media) => {
                return media.tags.damageId === queryParam[1];
              });
              break;
            case 'inspectionId':
              filteredMedia = filteredMedia.filter((media) => {
                return media.tags.inspectionId === parseInt(queryParam[1].toString());
              });
              break;
            case 'inspectionTaskId':
              filteredMedia = filteredMedia.filter((media) => {
                return media.tags.inspectionTaskId === parseInt(queryParam[1].toString());
              });
              break;
            default:
              break;
          }
        });
        return filteredMedia;
      })
    );
    // .subscribe((mediaData) => {
    //   console.log('this is mediaData');
    //   console.log(mediaData);
    //   let paramsArray = Object.entries(mediaData.queryParams);
    //   let filteredMedia: Media[] = mediaData.media;
    //   paramsArray.forEach((queryParam) => {
    //     switch (queryParam[0]) {
    //       case 'workOrderId':
    //         filteredMedia = filteredMedia.filter((media) => {
    //           return media.tags.workOrderId === parseInt(queryParam[1]);
    //         });
    //         break;
    //       case 'appointmentId':
    //         filteredMedia = filteredMedia.filter((media) => {
    //           return media.tags.appointmentId === parseInt(queryParam[1]);
    //         });
    //         break;
    //       case 'damageId':
    //         filteredMedia = filteredMedia.filter((media) => {
    //           return media.tags.damageId === queryParam[1];
    //         });
    //         break;
    //       case 'inspectionId':
    //         filteredMedia = filteredMedia.filter((media) => {
    //           return media.tags.inspectionId === parseInt(queryParam[1]);
    //         });
    //         break;
    //       case 'inspectionTaskId':
    //         filteredMedia = filteredMedia.filter((media) => {
    //           return media.tags.inspectionTaskId === parseInt(queryParam[1]);
    //         });
    //         break;
    //       default:
    //         break;
    //     }
    //   });
    //   //this.mediaSubject$.next(this.groupByPipe.transform(filteredMedia, 'tags.workOrderId'));
    // });
  }

  filterMedia(queryParams: any) {
    let navExtras: NavigationExtras = {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    };

    this.routerStateService.go('', navExtras);
  }

  clearFilterMedia() {
    let navExtras: NavigationExtras = {
      queryParams: {},
    };
    this.routerStateService.go('', navExtras);
  }
  navigateToAppointment(){
    this.location.back();
  }

}
